"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var application_1 = require("../../models/application");
var csod = require("player-core");
var constants = require("../../shared/code/Constants");
function view() {
    var _this = this;
    var getQuestionsByProps = function (props) { return props.actionItem.eeoQuestions.map(function (x) { return Object.assign(x, {
        label: (x.id === 7 && !csod.viewModel.isTMNTApril2021Enabled) ? '' : x.label,
        expandableFadeHeight: x.id === 7 ? '95px' : '200px',
        showLessText: csod.viewModel.EEOShowLessText,
        showMoreText: csod.viewModel.EEOShowMoreText,
    }); }); };
    return {
        state: {
            actionItem: this.props.actionItem,
            questions: getQuestionsByProps(this.props),
            parentTag: "",
            previewMessage: csod.locales.get("ATS.Player.ResponsiveApplication.EeoQuestionPreviewMessage", "When this requisition is active, compliance questions will be displayed here."),
            showPreviewMessage: csod.viewModel.isPreview,
            constants: constants
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
            _this.view.state.parentTag = _this.view.state.actionItem.type + "-" + _this.view.state.actionItem.id;
            _this.view.helpers.returnResultsToPage();
        },
        receivedProps: function (nextProps) {
            _this.view.state.actionItem = nextProps.actionItem;
            _this.view.state.questions = getQuestionsByProps(nextProps),
                _this.view.state.parentTag = _this.view.state.actionItem.type + "-" + _this.view.state.actionItem.id;
            _this.view.helpers.returnResultsToPage();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onQuestionAnswered: function (questionId, responseId) {
                for (var _i = 0, _a = _this.view.state.actionItem.eeoQuestions; _i < _a.length; _i++) {
                    var question = _a[_i];
                    if (question.id == questionId) {
                        question.selectedResponse = responseId;
                        if (question.followUpResponseId != undefined && question.followUpResponseId == responseId) {
                            question.displayFolloUpQuestion = true;
                        }
                        else {
                            question.displayFolloUpQuestion = false;
                            question.followUpEeoQuestion.selectedResponse = "0";
                        }
                        break;
                    }
                    else if (question.followUpEeoQuestion.id != 0 && question.followUpEeoQuestion.id == questionId) {
                        question.followUpEeoQuestion.selectedResponse = responseId;
                        break;
                    }
                }
                _this.view.helpers.returnResultsToPage();
            }
        },
        helpers: {
            returnResultsToPage: function () {
                var resultData = new application_1.EEOQuestionsResultData();
                resultData.actionId = _this.view.state.actionItem.id;
                resultData.type = application_1.ActionType.eeoQuestions;
                for (var _i = 0, _a = _this.view.state.actionItem.eeoQuestions; _i < _a.length; _i++) {
                    var question = _a[_i];
                    var userResponse = new application_1.EEOQuestionUserResponse();
                    userResponse.eeoQuestionId = question.id;
                    userResponse.eeoQuestionResponseId = question.selectedResponse;
                    resultData.answers.push(userResponse);
                    if (question.followUpEeoQuestion.id != 0) {
                        var dependentResponse = new application_1.EEOQuestionUserResponse();
                        dependentResponse.eeoQuestionId = question.followUpEeoQuestion.id;
                        dependentResponse.eeoQuestionResponseId = question.followUpEeoQuestion.selectedResponse;
                        resultData.answers.push(dependentResponse);
                    }
                }
                _this.props.onDataChanged(resultData);
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/ApplicationWorkflowEEOQuestionAction/View.js
// module id = 799
// module chunks = 0